import { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { FiMoreVertical } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';

export default function EmployeeActions({ employee, onDeleteEmployee, onActivateEmployee }) {
  const navigate = useNavigate();
  const trigger = useRef(null);
  const menu = useRef(null);
  const [position, setPosition] = useState(null);
  useEffect(() => {
    if (!position) return;
    const close = () => setPosition(null);
    const outside = event => { if (!menu.current?.contains(event.target) && !trigger.current?.contains(event.target)) close(); };
    const key = event => { if (event.key === 'Escape') { close(); trigger.current?.focus(); } };
    document.addEventListener('pointerdown', outside);
    document.addEventListener('keydown', key);
    window.addEventListener('resize', close);
    window.addEventListener('scroll', close, true);
    return () => {
      document.removeEventListener('pointerdown', outside);
      document.removeEventListener('keydown', key);
      window.removeEventListener('resize', close);
      window.removeEventListener('scroll', close, true);
    };
  }, [position]);
  const action = fn => { setPosition(null); fn(); };
  return <>
    <button ref={trigger} type="button" aria-label={`Actions for ${employee.name || employee.fullName || 'employee'}`} aria-expanded={!!position} aria-haspopup="menu" className="inline-flex h-10 w-10 items-center justify-center rounded-xl border border-gray-200 text-gray-600 hover:bg-primary-50 hover:text-primary-800" onClick={() => {
      if (position) return setPosition(null);
      const rect = trigger.current.getBoundingClientRect();
      setPosition({ left: Math.max(8, Math.min(rect.right - 192, window.innerWidth - 200)), top: rect.bottom + 8, above: window.innerHeight - rect.bottom < 210, bottom: window.innerHeight - rect.top + 8 });
    }}><FiMoreVertical size={20} /></button>
    {position && createPortal(<div ref={menu} role="menu" aria-label="Employee actions" className="fixed z-[100] w-48 rounded-xl border border-gray-200 bg-white p-1.5 shadow-xl" style={{ left: position.left, ...(position.above ? { bottom: position.bottom } : { top: position.top }) }}>
      <button role="menuitem" type="button" className="block w-full rounded-lg px-3 py-2 text-left text-sm hover:bg-primary-50" onClick={() => action(() => navigate(`/admindashboard/employees/${employee.employeeId}`))}>View employee</button>
      <button role="menuitem" type="button" className="block w-full rounded-lg px-3 py-2 text-left text-sm hover:bg-primary-50" onClick={() => action(() => navigate(`/admindashboard/employees/${employee.employeeId}/edit`))}>Edit employee</button>
      {employee.status === 'Inactive' && <button role="menuitem" type="button" className="block w-full rounded-lg px-3 py-2 text-left text-sm text-primary-800 hover:bg-primary-50" onClick={() => action(() => onActivateEmployee?.(employee))}>Activate employee</button>}
      <button role="menuitem" type="button" className="block w-full rounded-lg px-3 py-2 text-left text-sm text-red-600 hover:bg-red-50" onClick={() => action(() => onDeleteEmployee?.(employee))}>Delete employee</button>
    </div>, document.body)}
  </>;
}
